<template>
  <RouterView />
</template>

<script setup>
import { useAuthStore } from '@/stores/auth'
import { useGlobalStore } from '@/stores/global'
import { onMounted } from 'vue'

const globalStore = useGlobalStore()
const authStore = useAuthStore()

onMounted(async () => {
  if (!authStore.isLoggedIn) await authStore.guestLogin()
})
</script>

<script>
export default {
  name: 'ServicesRouter'
}
</script>

<style lang="scss" scoped></style>
